const t = (o) => o == null;
export {
  t as isEmpty
};
